import {Alert, Button, Stack} from "react-bootstrap";
import React from "react";
import {useAlert, useAuth} from "../../context";
import {Link, useNavigate} from "react-router-dom";
import {ResponsiveContent} from "../ResponsiveNavTabs";
import {Formik, Form as FormikForm} from "formik";
import {PageTitle, SingleText} from "../_components";
import * as yup from "yup";


export function ForgotPassword() {
    return <ResponsiveContent body={<ForgotPasswordForm/>}/>
}

function ForgotPasswordForm() {

    const navigate = useNavigate();
    const {forgotPassword} = useAuth();
    const {success, error} = useAlert();

    const validationSchema = yup.object().shape({
        email: yup.string()
            .required("Email is mandatory.")
            .email("Email not valid"),
    })

    const value = {
        email: ""
    }

    function handleSubmit(values, actions) {
        forgotPassword(values)
            .then(resp => {
                if (resp.success) {
                    navigate("/");
                    success(<p>An email was sent to <i>{values.email}</i> with a reset password link.<br/>Check your email to reset your password.</p>);

                    if ("debug" in resp) {
                        const to = "/account/reset-password?token=" + resp.debug.jwt
                        success(<p><Alert.Link as={Link} to={to}>verify</Alert.Link></p>, "Verification!", {autoClose: false});
                    }
                } else {
                    error(resp.message, "Server error");
                }
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    return <>
        <PageTitle title="Forgot Password?">Type your email to receive a reset password link.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
            {({isSubmitting, resetForm}) => (
                <FormikForm>

                    <SingleText name="email" label="Email" maxLength="64"/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <Button as={Link} variant="link" to={-1}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>Submit</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>

    </>
}
